import { motion } from "framer-motion";

const EASE = [0.2, 0.7, 0.1, 1];

export const MaskLine = ({ children, delay = 0, play = true, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "110%", rotate: 3 }}
      animate={play ? { y: "0%", rotate: 0 } : undefined}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", as = "div" }) => {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </C>
  );
};

export const SectionLabel = ({ index, children }) => (
  <div className="flex items-center gap-4 font-mono text-xs uppercase tracking-[0.25em] text-zinc-400">
    <span className="text-[var(--acid)]">{index}</span>
    <span className="h-px w-10 bg-zinc-700" />
    <span>{children}</span>
  </div>
);
